module.exports = __webpack_public_path__ + "static/media/myphoto12.cf1f9f61.jpg";